import React from 'react';
import {ChoiceQuestionDto, OperateQuestionDto, FillQuestionDto, QuestionDto, UserRole} from '../../scaffold';
import MarkdownRender from '../Shared/MarkdownRender';
import Flex from '../Shared/Flex';
import Text from 'antd/lib/typography/Text';
import {IQuestionDisplayProps} from './QuestionDisplay';
import useAuth from '../../utils/AuthContext';

export default function OperateQuestionDisplay(props: IQuestionDisplayProps<OperateQuestionDto>) {
  const {question} = props;
  const auth = useAuth();
  const isStudent = auth.currentUser?.role === UserRole.学生;
  return (
    <div>
      <MarkdownRender className={'smallMarkdown'} md={'**[' + (isStudent ? '操作关' : '操作题') + ']** ' + question.topic || ''} />
    </div>
  );
}
